import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProceduresActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.3,
		d: "M5.667 3.65h5.977c.269 0 .528.108.718.298l2.357 2.357c.19.19.298.45.298.718v9.31c0 .562-.455 1.017-1.017 1.017H5.667a1.016 1.016 0 0 1-1.017-1.017V4.667c0-.562.455-1.017 1.017-1.017"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "#e6e8fe",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.3,
		d: "M15.667 7.167h-3.334a.834.834 0 0 1-.833-.834V3M6.5 12.167h5M6.5 14.667h3.608"
	})]
});
export default SvgProceduresActive;
